export const AulasConteudo = ({ conteudo }) => {
  return (
    <div className="aulas-video-wrapper-player">
      <p style={{ fontSize: 14 }}>{conteudo}</p>
    </div>
  );
};
